import axios from "axios";
export default {
    methods: {
        async asyncAxiosGet(url, auth, params) {
            return await new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + url,
                    params: params,
                    auth: auth ? {
                        username: auth.username,
                        password: auth.password,
                    } : null,
                    headers: auth ? {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": 'application/json',
                    } : null,
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        let response = Object.assign({}, err.response);
                        if (response.data.status == false && response.data.message) {
                            this.displayMessageValue("error-other", response.data.message);
                        } else {
                            let responses = Object.assign({}, err.response.data);
                            this.displayMessageValue("error", responses);
                        }
                        reject(err);
                    });
            });
        },
        axiosGet(url, auth, params) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + url,
                    params: params,
                    auth: auth ? {
                        username: auth.username,
                        password: auth.password,
                    } : null,
                    headers: auth ? {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": 'application/json',
                    } : null,
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        let response = Object.assign({}, err.response);
                        if (response.data.status == false && response.data.message) {
                            this.displayMessageValue("error-other", response.data.message);
                        } else {
                            let responses = Object.assign({}, err.response.data);
                            this.displayMessageValue("error", responses);
                        }
                        reject(err);
                    });
            });
        },
        async asyncAxiosPost(url, type, auth, params) {
            return await new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + url,
                    data: params,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: type == "formdata" ?
                        {
                            "X-API-KEY": auth.apikey,
                            "Content-Type": "multipart/form-data",
                        } :
                        {
                            "X-API-KEY": auth.apikey,
                            "Content-Type": 'application/json',
                        },
              
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        let response = Object.assign({}, err.response);
                        if (response.data.status == false && response.data.message) {
                            this.displayMessageValue("error-basic", response.data.message);
                        } else {
                            let responses = Object.assign({}, err.response.data);
                            this.displayMessageValue("error", responses);
                        }
                        reject(response);
                    });
            });
        },
        async asyncAxiosPut(url, type, auth, params) {
            return await new Promise((resolve, reject) => {
                axios({
                    method: "put",
                    url: process.env.VUE_APP_SERVICEURL + url,
                    data: params,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: type == "formdata" ?
                        {
                            "X-API-KEY": auth.apikey,
                            "Content-Type": "multipart/form-data",
                        } :
                        {
                            "X-API-KEY": auth.apikey,
                            "Content-Type": 'application/json',
                        },
              
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        let response = Object.assign({}, err.response);
                        if (response.data.status == false && response.data.message) {
                            this.displayMessageValue("error-other", response.data.message);
                        } else {
                            let responses = Object.assign({}, err.response.data);
                            this.displayMessageValue("error", responses);
                        }
                        reject(response);
                    });
            });
        },
        async asyncAxiosDelete(url, type, auth, params) {
            return await new Promise((resolve, reject) => {
                axios({
                    method: "delete",
                    url: process.env.VUE_APP_SERVICEURL + url,
                    data: params,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: type == "formdata" ?
                        {
                            "X-API-KEY": auth.apikey,
                            "Content-Type": "multipart/form-data",
                        } :
                        {
                            "X-API-KEY": auth.apikey,
                            "Content-Type": 'application/json',
                        },
              
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        let response = Object.assign({}, err.response);
                        if (response.data.status == false && response.data.message) {
                            this.displayMessageValue("error-other", response.data.message);
                        } else {
                            let responses = Object.assign({}, err.response.data);
                            this.displayMessageValue("error", responses);
                        }
                        reject(response);
                    });
            });
        },

        async asyncAxiosFile(url, auth, params){
            return await new Promise((resolve, reject) => {
                axios({
                    method: 'GET',
                    url: process.env.VUE_APP_SERVICEURL + url,
                    params: {
                      "X-API-KEY": auth.apikey,
                      file: params.fileName ? params.fileName : null,
                      params
                    },
                    auth: {
                        username: auth.username,
                        password: auth.password
                    },
                    responseType: 'blob'
                }).then((response) => {
                    resolve(response)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        onlyNumber (event) {
            //console.log(event); //keyCodes value
            
            let keyCode = (event.keyCode ? event.keyCode : event.which);
      
            // Detecting Ctrl
            var ctrl = event.ctrlKey ? event.ctrlKey : ((keyCode === 17)
            ? true : false);
      
            if (((//keyCode < 48 ||  
                    keyCode > 57)                   // numeric alphabet
                && (keyCode < 96 || keyCode > 105)  // numeric number
               // && keyCode !== 46 // 46 is backspace
                //&& keyCode !== 8  // 8 is delete
                //&& keyCode !== 9  // 8 is Tab
                && keyCode !== 190  // 8 is titik titik separator dibelakang koma / desimal
                && keyCode !== 110 // 110 is titik separator dibelakang koma / desimal
                && keyCode !== 110 // 110 is titik separator dibelakang koma / desimal
                ) 
                && !( (ctrl && keyCode == 65)   // allow ctrl+A
                    || (ctrl && keyCode == 67)  // allow ctrl+C
                    || (ctrl && keyCode == 86)) // allow ctrl+V
            ) 
            { 
      
              event.preventDefault();
              
            }else{
              let desimal = event.target.value.split(".");
              if (desimal.length>1
                && keyCode !== 46 // 46 is backspace
                && keyCode !== 8  // 8 is delete
                && keyCode !== 9  // 8 is Tab
                && keyCode !== 65 // ctrl+A
                ){
                if (desimal[1].length==2){
                  event.preventDefault();
                }
              }
            }
        },
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        fileTypeFromUrl(file_nm) {
            let typefile = file_nm.substr(file_nm.lastIndexOf("."));
            typefile = typefile.toLowerCase()
                
            if (typefile == ".xls") {
                typefile = "data:application/vnd.ms-excel;base64,";
            } else if (typefile == ".xlsx") {
                typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
            } else if (typefile == ".doc") {
                typefile = "data:application/msword;base64,";
            } else if (typefile == ".docx") {
                typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
            } else if (typefile == ".pdf") {
                typefile = "data:application/pdf;base64,";
            } else if (typefile == ".jpeg" || typefile == ".jpg") {
                typefile = "data:image/jpeg;base64,";
            } else if (typefile == ".png") {
                typefile = "data:image/png;base64,";
            } else if (typefile == ".zip") {
                typefile = "data:application/zip;base64,";
            } else if (typefile == ".rar") {
                typefile = "data:application/rar;base64,";
            } else if (typefile == ".ppt") {
                typefile = "data:application/vnd.ms-powerpoint;base64,";
            } else if (typefile == ".pptx") {
                typefile = "data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,";
            } 
            return typefile
        },
    }
}